import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import useAuth from '../../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import { CommonButton } from '../../../../Styles/CommonStyles';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useUpdateassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import UnivMyAssetCom from '../../Myasset/UnivMyAssetComp';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { generateAssetsPDF } from '../utils/pdfGenerator';
import { useLazyGetAssetsFinalFilteredQuery, useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';

const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;

const ActionButton = styled(Button)`
  background-color: #1976d2;
`;

const ReturnButton = styled(Button)`
  background-color: #ff9800;
`;

const RejectButton = styled(Button)`
  background-color: #f44336;
`;

const ForwardButton = styled(Button)`
  background-color: #4caf50;
`;

const IssueButton = styled(Button)`
  background-color: #ff9800;
`;

const FinalIssueButton = styled(Button)`
  background-color: #2e7d32;
`;

const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  overflow: 'auto'
};

const PartialAssetsModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px'
};

const ModalTitle = styled.h2`
  margin-bottom: 20px;
  color: #1976d2;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
`;

const SelectedAssetsContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const SelectedAssetsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const SelectedAssetsTitle = styled.h3`
  margin-bottom: 0;
  color: #1976d2;
`;

const StyledTableContainer = styled(TableContainer)`
  margin-bottom: 20px;
`;

const StyledTableHead = styled(TableHead)`
  background-color: #1976d2;
  
  & th {
    color: white;
    font-weight: bold;
  }
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const SummaryContainer = styled.div`
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
`;

const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

const SummaryItemName = styled.span`
  font-weight: 500;
  margin-right: 10px;
`;

const SummaryItemCount = styled.span`
  background-color: #1976d2;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.8rem;
`;

const OptionButton = styled(Button)`
  margin: 8px 0;
  width: 100%;
  padding: 12px;
  justify-content: flex-start;
  text-transform: none;
  font-weight: 500;
`;

const ForwardStoreButton = styled(OptionButton)`
  background-color: #2196f3;
`;

const CloseRequestButton = styled(OptionButton)`
  background-color: #f44336;
`;

const BoInboxForm = ({ row, handleBack, selectedOptions, setSelectedOptions }) => {
  const isFirstRender = useRef(true);
  const [remark, setRemark] = useState('');
  const [openAssetModal, setOpenAssetModal] = useState(false);
  const [openPartialModal, setOpenPartialModal] = useState(false);
  const [filterProps, setFilterProps] = useState({});
  const [validationResults, setValidationResults] = useState({
    result:[], alerts:[], partialIssue:true
  });
  const [assetsModified, setAssetsModified] = useState(false);
  const [tempSelectedOptions, setTempSelectedOptions] = useState([]);
  const [confirmed, setConfirmed] = useState(false);
  const [filters, setFilters] = useState({});

  const auth = useAuth();
  let user_current_office = (useSelector((state) => state.office.off));
  

  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  const { officedata } = useGetofficesQuery('offices', {
    selectFromResult: ({ data }) => ({
      officedata: data?.entities
    }),
  });

  const BO_id = officedata ? Object.values(officedata)?.find(office => office?.name === user_current_office)?.Bo : "";
  const UnitHead_id = officedata ? Object.values(officedata)?.find(office => office?.name === user_current_office)?.unitHead : "";

  const [updateReq] = useUpdateassetReqMutation();
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();

  // Lazy query to fetch data only when triggered
  const [fetchAllData, { data: allData, isLoading: allDataLoading }] = useLazyGetAssetsFinalFilteredQuery();

  // Check if this is a request returned from Unit Head for modification
  const isReturnedFromUH = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'uhreq_bolvl_rtrned_mod';
  
  // Check if this is a request resubmitted by user after modification
  const isResubmittedByUser = row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'ureq_resubmit_modified';

  // Check if assets were previously issued before being sent to Unit Head
  const hasAssetsIssued = row?.bo_assets_issue && row.bo_assets_issue.length > 0 && row.bo_assets_issue[row.bo_assets_issue.length - 1]?.assets?.length > 0;

  // Initialize filter props for asset selection
  useEffect(() => {
    setFilterProps({ perm_cur_loc: ["office"], perm_alloc_ofc: [user_current_office] });
  }, [user_current_office]);

  // Initialize selectedOptions if BO assets available in array.
  useEffect(() => {
    if(row?.bo_assets_issue?.length && row?.bo_assets_issue?.[row?.bo_assets_issue.length - 1]?.status === "draft") {
      setFilters( prev => (
        {...prev, perm_ids: row?.bo_assets_issue?.[row?.bo_assets_issue.length - 1]?.assets}
      ))     
    }
  }, [row]);

  // Fetch all data when filters change
  useEffect(() => {
    if (Object.keys(filters)?.length) {
      fetchAllData({
        page: 1,
        limit: 99999, // Fetch all filtered data
        filters,
      });
    }
  }, [filters, fetchAllData]);

  // Set selected options based on fetched data
  useEffect(() => {
    if ( isFirstRender.current && allData?.assets?.length ) {
      setSelectedOptions(allData?.assets);
      isFirstRender.current = false; // Prevent future runs
    } 
  }, [allData]);

  console.log("Selected Options:", selectedOptions);

  // Update assetsModified state when selectedOptions changes
  useEffect(() => {
    setAssetsModified(selectedOptions && selectedOptions.length > 0);
    console.log(row?.bo_assets_issue?.length)
    if ( selectedOptions?.length ) {
      const latestRequestedAssets = row.assets_requested[row.assets_requested.length - 1].data;
      const validationResults = validateAssets(latestRequestedAssets, selectedOptions);
      console.log(validationResults);
      setValidationResults(validationResults);
    }
  }, [selectedOptions]);

 // Function to check if two asset arrays are equal
  function areAssetArraysEqual(arr1, arr2) {

    if (arr1?.length !== arr2?.length) return false;
  
    const ids1 = arr1.map(asset => asset._id).sort();
    const ids2 = arr2.map(asset => asset._id).sort();
  
    return ids1.every((id, index) => id === ids2[index]);
  }  

  // Function to validate assets
  function validateAssets(requested, available) {
    const result = [];
    const alerts = [];
    let partialIssue = false;

    if(!requested || !available) {
      partialIssue = true;
      return { result, alerts, partialIssue };
    }

    const requestMap = {};
    for (const req of requested) {
      requestMap[req.assetName] = parseInt(req.quantity, 10);
    }

    // Group available assets by name
    const availableMap = {};
    for (const asset of available) {
      const key = asset.name;
      if (!availableMap[key]) {
        availableMap[key] = [];
      }
      availableMap[key].push(asset);
    }

    // Validate requested assets
    for (const [name, quantity] of Object.entries(requestMap)) {
      const matchingAssets = availableMap[name] || [];
      const availableQty = matchingAssets.length;

      if (availableQty > quantity) {
        alerts.push(`More assets selected for "${name}" than requested (requested ${quantity}, found ${availableQty}).`);
      } else if (availableQty < quantity) {
        partialIssue = true; // Partial issue identified
      }

      result.push({
        assetName: name,
        required: quantity,
        available: availableQty,
        matchedAssets: matchingAssets.slice(0, quantity)
      });

      delete availableMap[name];
    }

    // Check for unexpected asset types
    for (const unexpected of Object.keys(availableMap)) {
      alerts.push(`Unexpected asset found: "${unexpected}" is not in the requested list.`);
      result.push({
        assetName: unexpected,
        required: 0,
        available: availableMap[unexpected].length,
        matchedAssets: availableMap[unexpected]
      });
    }

    return { result, alerts, partialIssue };
  }

  // Handler for issue assets button
  const handleIssueAssets = () => {
    // Store current selections as temporary selections when opening the modal
    setTempSelectedOptions([...selectedOptions]);
    setConfirmed(false);
    setOpenAssetModal(true);
  };

  // Handler for closing the asset modal
  const handleCloseModal = () => {
    setOpenAssetModal(false);
    
  // If selections were not confirmed, restore previous selections
  if (!confirmed) {
      setSelectedOptions([...tempSelectedOptions]);
  }
  };

  // Handler for confirming asset selection
  const handleConfirmSelection = () => {
    if (selectedOptions?.length === 0) {
      alert("Please select at least one asset to issue.");
      // Reset assetsModified flag if no assets are selected
      setAssetsModified(false);
      return;
    }

    if (validationResults?.alerts?.length) {
      alert("⚠️ Alerts:\n" + validationResults.alerts.join("\n"));
      return;
    }

    // Mark that assets have been modified and confirmed
    setAssetsModified(true);
    setConfirmed(true);
    setOpenAssetModal(false);
    alert("Assets selected for issue.");
  };

  // Handler for the issue partial assets button
  const handleFinalIssue = () => {
    if (selectedOptions.length === 0) {
      alert("Please select assets to issue");
      return;
    }

    if (validationResults?.partialIssue) {
      // Open modal for partial assets options
      setOpenPartialModal(true);
    } else {
      // Regular full issuance
      handleAssetIssue('full');
    }
  };
console.log(areAssetArraysEqual(selectedOptions.map( x => x.id), row?.bo_assets_issue[row.bo_assets_issue.length - 1]?.assets))
  // Unified handler for asset issuance with different types
  const handleAssetIssue = async (issueType) => {
    let sent_to_tag, action, successMessage;
    
    switch(issueType) {
      case 'full':
        sent_to_tag = "boreq_issueallclose_forapprv";
        action = "All requested assets have been issued and sent to Unit Head for approval.";
        successMessage = "All requested assets have been issued and sent to Unit Head for approval.";
        break;
      case 'partialForward':
        sent_to_tag = "boreq_parissue_forapprv";
        action = "Partial assets issued and forwarded to store";
        successMessage = "Partial assets issued and sent to Unit Head for approval before forwarding to store.";
        break;
      case 'partialClose':
        sent_to_tag = "boreq_parissueclse_forapprv";
        action = "Partial assets issued and request closed";
        successMessage = "Partial assets issued and sent to Unit Head for approval before closing the request.";
        break;
      default:
        alert("Invalid issue type");
        return;
    }
    
    // Common data for all types
    let senttoData = {
      sent_to_tag,
      Text: remark,
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: UnitHead_id, name: getSingleuser?.[UnitHead_id]?.name, office: user_current_office, designation: getSingleuser?.[UnitHead_id].designation?.[user_current_office] },
      action: action,
      ...( !areAssetArraysEqual(selectedOptions.map( x => x.id), row?.bo_assets_issue[row.bo_assets_issue.length - 1]?.assets) && {
        bo_assets_issue: {
          time_stamp: new Date(),
          status: "draft",
          assets: selectedOptions.map(x => x.id)
        }
      }),
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[UnitHead_id])}-${user_current_office}-${getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      opened: false
    };
    
    const assetBody = {
      "assetIdArray": selectedOptions.map(x => x.id),
      "updates": {
        "in_transit": true,
      }
    }
    
    const body = { id: row?._id, senttoData: senttoData };

    try {
      const res = await updateReq(body);
      const res2 = await updateMultipleAssetDocs(assetBody);
      alert(successMessage);
      
      // Close modal for partial cases
      if (issueType === 'partialForward' || issueType === 'partialClose') {
        setOpenPartialModal(false);
      }
      
      handleBack();
    } catch (error) {
      console.error("Error issuing assets:", error);
      alert("There was an error issuing the assets. Please try again.");
    }
  };

console.log(validationResults)
  // Handler for closing the partial assets modal
  const handleClosePartialModal = () => {
    setOpenPartialModal(false);
  };

  // Handler for returning request to user for modification
  const handleReturnBack = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark explaining what needs to be modified.");
      return;
    }

    let senttoData = {
      sent_to_tag: "boreq_back_user_mod",
      Text: remark,
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: row?.req_creator_id, name: getSingleuser?.[row?.req_creator_id]?.name, office: row?.req_data[0]?.sent_by?.office, designation: row?.req_data[0]?.sent_by?.designation },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[row?.req_creator_id])}-${row?.req_data[0]?.sent_by?.office}-${getSingleuser?.[row?.req_creator_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      action:'Request Returned to User for Modification',
      opened: false
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      const res = await updateReq(body);
      alert("Request returned to requester for modification.");
      handleBack();
    } catch (error) {
      console.error("Error returning request:", error);
      alert("There was an error returning the request. Please try again.");
    }
  };

  // Handler for rejecting request
  const handleRejectRequest = async () => {
    if (!remark.trim()) {
      alert("Please provide a reason for rejecting the request.");
      return;
    }

    let senttoData = {
      sent_to_tag: "boreq_rejct_closed",
      Text: remark,
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: row?.req_creator_id, name: getSingleuser?.[row?.req_creator_id]?.name, office: row?.req_data[0]?.sent_by?.office, designation: row?.req_data[0]?.sent_by?.designation },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[row?.req_creator_id])}-${row?.req_data[0]?.sent_by?.office}-${getSingleuser?.[row?.req_creator_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Rejected",
      action:'Request Rejected and Returned to User',
      opened: false
    };

    const assetBody = {
      assetIdArray: [
        ...(row?.bo_assets_issue?.[row.bo_assets_issue.length - 1]?.assets || []),
        ...(row?.store_assets_issue?.[row.store_assets_issue.length - 1]?.assets || [])
      ],
      updates: {
        in_transit: false,
      }
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      const res = await updateReq(body);
      const res2 = await updateMultipleAssetDocs(assetBody);

      alert("Request rejected successfully");
      handleBack();
    } catch (error) {
      console.error("Error rejecting request:", error);
      alert("There was an error rejecting the request. Please try again.");
    }
  };

  // Handler for forwarding request to unit head
  const handleForwardToUnitHead = async () => {
    if(UnitHead_id === "" || !UnitHead_id) {
      return alert("No Unit Head assigned for your office. Please contact admin.");
    }
    let senttoData = {
      sent_to_tag: "boreq_fwd_unithead",
      Text: remark,
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: UnitHead_id, name: getSingleuser?.[UnitHead_id]?.name, office: user_current_office, designation: getSingleuser?.[UnitHead_id].designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[UnitHead_id])}-${user_current_office}-${getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      action:'Request Forwarded to Unit Head for Store',
      opened: false
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      const res = await updateReq(body);
      alert("Request forwarded to Unit Head successfully");
      handleBack();
    } catch (error) {
      console.error("Error forwarding request:", error);
      alert("There was an error forwarding the request. Please try again.");
    }
  };

  // Generate summary data from selected assets
  const generateSummary = (assets) => {
    if (!assets || assets.length === 0) return [];

    const summary = assets.reduce((acc, asset) => {
      const { name } = asset;
      if (!acc[name]) {
        acc[name] = 0;
      }
      acc[name]++;
      return acc;
    }, {});

    return Object.entries(summary).map(([name, count]) => ({ name, count }));
  };

  // Handle PDF generation
  const handlePrintPDF = () => {
    generateAssetsPDF({
      assets: selectedOptions,
      remark: remark,
      title: 'Selected Assets for Issue'
    });
  };

  // Format specifications for display
  const formatSpecifications = (specs) => {
    if (!specs) return '-';

    return Object.entries(specs)
      .slice(0, 3) // Take only first 3 specifications
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
  };

  const columnFilter = ["OEM/ORG Tag", "OEM/Brand", "Purchase Date", "Warranty Date", "Detail", "Model"];

  // Add a new handler for clearing all asset selections
  const handleClearAllSelections = () => {
    setSelectedOptions([]);
    // Mark as confirmed so the empty selection persists when closing the modal
    setConfirmed(true);
    alert("All assets have been deselected.");
  };

  return (
    <>
      <RemarkContainer>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Add Remark"
          variant="outlined"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </RemarkContainer>

      {/* Display selected assets in a table if available */}
      {selectedOptions?.length > 0 && (
        <SelectedAssetsContainer>
          <SelectedAssetsTitleContainer>
            <SelectedAssetsTitle>Selected Assets for Issue</SelectedAssetsTitle>
            <ActionButtonsContainer>
              <Tooltip title="Edit selections">
                <IconButton color="primary" onClick={handleIssueAssets}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print as PDF">
                <IconButton color="primary" onClick={handlePrintPDF}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
            </ActionButtonsContainer>
          </SelectedAssetsTitleContainer>

          {/* Summary section */}
          <SummaryContainer>
            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>
              Total: {selectedOptions?.length} items
            </span>
            {generateSummary(selectedOptions).map((item, index) => (
              <SummaryItem key={index}>
                <SummaryItemName>{item.name}</SummaryItemName>
                <SummaryItemCount>{item.count}</SummaryItemCount>
              </SummaryItem>
            ))}
          </SummaryContainer>

          <StyledTableContainer component={Paper}>
            <Table>
              <StyledTableHead>
                <TableRow>
                  <TableCell>Sl.No.</TableCell>
                  <TableCell>OEM Tag</TableCell>
                  <TableCell>ORG Tag</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Specifications</TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {selectedOptions?.map((asset, index) => (
                  <TableRow key={asset._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{asset.oem_tag}</TableCell>
                    <TableCell>{asset.org_tag}</TableCell>
                    <TableCell>{asset.name}</TableCell>
                    <TableCell>{formatSpecifications(asset.specification)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </SelectedAssetsContainer>
      )}

      <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>

        { ( selectedOptions?.length === 0) &&
          <ForwardButton onClick={handleForwardToUnitHead}>
              Forward to Unit Head for Store
          </ForwardButton>}
        { ( selectedOptions?.length === 0) &&
          <IssueButton onClick={handleIssueAssets}>
            Issue Office Assets
          </IssueButton>
        }
        { ( selectedOptions?.length !== 0) &&
          <FinalIssueButton onClick={handleFinalIssue}>
                {validationResults?.partialIssue ? "Issue Partial Assets" : "Issue Assets"}
          </FinalIssueButton>
        }
        { ( selectedOptions?.length === 0) &&
          <ReturnButton onClick={handleReturnBack}>
            Return to User for Modification
          </ReturnButton>
        }
        { ( selectedOptions?.length === 0) &&  
          <RejectButton onClick={handleRejectRequest}>
            Reject Request
          </RejectButton>
        }
       
      </div>

      {/* Modal for Asset Selection */}
      <Modal
        open={openAssetModal}
        onClose={handleCloseModal}
        aria-labelledby="asset-selection-modal"
      >
        <Box sx={ModalStyle}>
          <ModalTitle>Select Assets to Issue</ModalTitle>

          <UnivMyAssetCom
            filterProps={filterProps}
            checkbox={true}
            columnFilter={columnFilter}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
          />

          <ModalFooter>
            <Button onClick={handleCloseModal}>Cancel</Button>
            <Button 
              onClick={handleClearAllSelections}
              style={{ backgroundColor: '#f44336', marginRight: 'auto' }}
            >
              Clear All
            </Button>
            <ActionButton onClick={handleConfirmSelection}>Confirm Selection</ActionButton>
          </ModalFooter>
        </Box>
      </Modal>

      {/* Modal for Partial Assets Options */}
      <Modal
        open={openPartialModal}
        onClose={handleClosePartialModal}
        aria-labelledby="partial-assets-modal"
      >
        <Box sx={PartialAssetsModalStyle}>
          <ModalTitle>Partial Assets Issue Options</ModalTitle>

          <div style={{ marginBottom: '20px' }}>
            You are about to issue fewer assets than requested. Please select an option:
          </div>

          <ForwardStoreButton onClick={() => handleAssetIssue('partialForward')}>
            Send to Unit Head for Issuing Partial Assets and Forwarding Request to Store
          </ForwardStoreButton>

          <CloseRequestButton onClick={() => handleAssetIssue('partialClose')}>
            Send to Unit Head for Issuing Partial Assets and Close Request
          </CloseRequestButton>

          <ModalFooter>
            <Button onClick={handleClosePartialModal}>Cancel</Button>
          </ModalFooter>
        </Box>
      </Modal>
    </>
  );
};

export default BoInboxForm; 